import { FileServiceApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useUpload() {
  const { mutateAsync } = useAuthMutation(FileServiceApi.uploadContentsImage);

  const handleUploadd = async (file: File) => {
    return await mutateAsync(file);
  };

  return { handleUploadd };
}

export default useUpload;
